module.exports = __webpack_public_path__ + "static/pic13-8772143a90461e0e4e312dbe3ebfd08f.png";